import { isNil } from 'lodash/fp';
// eslint-disable-next-line max-len
import { type ImageDescriptionWebPageBlockDataFragment } from '../../../../../api/fragments/ImageDescriptionWebPageBlockData';
import usePublic from '../../../../../utilities/usePublic';
import useTranslatedString from '../../../../../utilities/useTranslatedString';
import { ImageListRow, ImageListImageContainer, StyledImage, ImageListTitle, ImageListDescription } from '../shared';

type ImageListProps = {
    descriptions: ImageDescriptionWebPageBlockDataFragment[];
};

const ImageList = ({ descriptions }: ImageListProps) => {
    const fallbackSrc = usePublic('empty.svg');
    const translated = useTranslatedString();

    return (
        <div>
            {descriptions.length > 0 &&
                descriptions.map(description => {
                    const iconSrc = !isNil(description.icon) ? description.icon.url : fallbackSrc;

                    return (
                        <ImageListRow>
                            <ImageListImageContainer>
                                <StyledImage preview={false} src={iconSrc} />
                            </ImageListImageContainer>
                            <div>
                                <ImageListTitle level={5}>{translated(description.title)}</ImageListTitle>
                                <ImageListDescription>{translated(description.description)}</ImageListDescription>
                            </div>
                        </ImageListRow>
                    );
                })}
        </div>
    );
};

export default ImageList;
